import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  descriptionText: {
    defaultValue:
      'Esta mudança será aplicada para todos os workspaces e usuários. Usuários que tenham esses nichos salvos ou em dashboards verão o nicho como descontinuado. Não é possível reverter.',
    key: 'ConfirmNicheAction-descriptionText',
  },
  confirmText: {
    defaultValue: 'Deseja confirmar a ação?',
    key: 'ConfirmNicheAction-confirmText',
  },
})
